import { Input } from '@design-system';

interface QuestionBodyShortTextProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
}

export function QuestionBodyShortText({
  value,
  onChange,
  placeholder,
  disabled,
}: QuestionBodyShortTextProps) {
  return (
    <Input
      autoFocus
      value={value}
      onChange={e => onChange(e.target.value)}
      placeholder={placeholder}
      disabled={disabled}
    />
  );
}
